export default __webpack_public_path__ + "static/Brixton_Wood-Vector-2943ebeb31d516d63acdc3307b207dd9.woff";